import { createContext, useContext } from "react";
import type {
  FileUploadState,
  UploadOptions,
  AggregatedResult,
} from "@/hooks/useFileUpload";

export interface UploadContextType {
  state: FileUploadState;
  files: File[];
  isDialogOpen: boolean;
  isUploading: boolean;
  upload: (files: File[], options: UploadOptions) => Promise<AggregatedResult>;
  cancel: () => void;
  reset: () => void;
  openDialog: () => void;
  closeDialog: () => void;
  minimizeDialog: () => void;
  expandDialog: () => void;
  isMinimized: boolean;
}

const initialState: FileUploadState = {
  status: "idle",
  totalFiles: 0,
  completedFiles: 0,
  currentBatch: 0,
  totalBatches: 0,
  fileStatuses: new Map(),
};

export const UploadContext = createContext<UploadContextType>({
  state: initialState,
  files: [],
  isDialogOpen: false,
  isUploading: false,
  upload: async () => ({
    success: false,
    totalUploaded: 0,
    totalIgnored: 0,
    autoCategorizedDocs: [],
    ignoredDocs: [],
    batchResults: [],
    errors: ["Upload provider not initialized"],
  }),
  cancel: () => {
    console.warn("cancel not implemented");
  },
  reset: () => {
    console.warn("reset not implemented");
  },
  openDialog: () => {
    console.warn("openDialog not implemented");
  },
  closeDialog: () => {
    console.warn("closeDialog not implemented");
  },
  minimizeDialog: () => {
    console.warn("minimizeDialog not implemented");
  },
  expandDialog: () => {
    console.warn("expandDialog not implemented");
  },
  isMinimized: false,
});

export const useUploadContext = () => useContext(UploadContext);
